import { useState } from 'react';

import { useLocation, useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import { useAges } from '../../../hooks/useAges';
import { useSummerplayTypes } from '../../../hooks/useSummerplayTypes';
import genericModelTypes from '../../../provider/models/genericModelTypes';
import { fakeDelay, linkCheckSlash } from '../../../provider/utility';
import { selectedAge, selectedRobot } from '../../../store/actions';
import { serviceTypes } from '../../../store/initData/services';
import { env } from '../../../utils/env';
import AccordionOption from '../../AccordionOption/AccordionOption';
import FormLabel from '../../FormLabel/FormLabel';
import SelectOption from '../../SelectOption/SelectOption';
import SingleInputPage from '../SingleInputPage/SingleInputPage';
import { convertWorkshopLevelsToRobotAccordion, filterByAge } from './helpers';

export default function AgePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const currentPage = useSelector((store) => store.state.page);
  const currentService = useSelector((store) => store.state.service);
  const currentFranchise = useSelector((store) => store.state.city?.franchise);

  const { summerplayTypes } = useSummerplayTypes();

  const ageFormLabel = useSelector((store) => store.data.ageFormLabel);
  const { ages } = useAges();
  const currentAge = useSelector((store) => store.state.age);

  const robotFormLabel = useSelector((store) => store.data.robotFormLabel);
  let availableRobots = convertWorkshopLevelsToRobotAccordion(
    currentService.value === serviceTypes.workshop
      ? currentFranchise.levels
      : summerplayTypes,
  );
  if (currentAge) {
    availableRobots = filterByAge(availableRobots, currentAge.value);
  }
  const errorMessage = currentFranchise.messages.levelErrorMessage;

  const currentRobot = useSelector((store) => store.state.robot);

  const agePageTexts = useSelector((store) => store.data.agePage);

  const ageOptions = ages.map((gr) => ({
    text: gr.age_display,
    value: gr.age_int,
  }));
  const handleAgeSelection = (item) => {
    dispatch(selectedAge(item));
    navigate(
      `${env.PUBLIC_URL}/${currentService.value}/${currentFranchise.id}/${
        item.value || 0
      }`,
    );
  };

  const handleRobotSelection = (option) => {
    setLoading(true);
    dispatch(selectedRobot(option));
    fakeDelay(() => navigate(linkCheckSlash(location.pathname, option.value)));
  };

  const content = (
    <div>
      <FormLabel type="big">{ageFormLabel}</FormLabel>
      <AccordionOption
        data={ageOptions}
        selected={currentAge}
        onClick={handleAgeSelection}
        placeholder={agePageTexts.placeholder}
      />
      <FormLabel type="big">{robotFormLabel}</FormLabel>
      <SelectOption
        items={availableRobots}
        selected={currentRobot}
        onClick={handleRobotSelection}
        displayPrimaryButton={true}
      />
    </div>
  );

  return (
    <SingleInputPage
      setLoading={setLoading}
      page={currentPage}
      currentStep={currentPage.step}
      content={content}
      backButton={true}
      backButtonLink={`${env.PUBLIC_URL}/${currentService.value}`}
      nextButton={currentRobot && !loading}
      nextButtonLink={`./${currentRobot?.id}`}
      loading={loading}
      errorMessage={availableRobots.length === 0 ? errorMessage : false}
      genericMessageType={genericModelTypes.noLevel}
    />
  );
}
